// extracted by mini-css-extract-plugin
export default {"container":"TipWrapper_container__-8-w2","loadingWrapper":"TipWrapper_loadingWrapper__fEfzR","loading":"TipWrapper_loading__OphMZ","tipster":"TipWrapper_tipster__7qcx7"};